import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import PageHeader from '../common/PageHeader';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import { GenerateAbsoluteURL, getCurrentPayCycleEndDateByDate, getCurrentPayCycleStartDateByDate, removeDuplicates, disableDatesForPayCycleStart1, disableDatesForPayCycleEnd1, getValidEndDate, EnhancedTableHead, orderBy, getPreviousPayCycle, IsAutoRunPagesEnabled } from '../../utils/helper';
import { getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

const changeInAllocationEmployeeByProperty = [
  { key: 'effectiveAllocationStartDate', format: 'Date' },
  { key: 'effectiveAllocationEndDate', format: 'Date' },
  { key: 'effectiveBillingStartDate', format: 'Date' },
  { key: 'effectiveBillingEndDate', format: 'Date' },
  { key: 'allocationPercent', format: 'TextNew' },
  { key: 'billingPercent', format: 'TextNew' },
  { key: 'additionalFixedAmount', format: 'TextNew' }
];

// Table column headers
const headCells = [
  {
    id: 'email',
    numeric: false,
    disablePadding: true,
    label: 'Email',
    type: 'Text'
  },
  {
    id: 'effectiveAllocationStartDate',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Start Date',
    type: 'Text'
  },
  {
    id: 'effectiveAllocationEndDate',
    numeric: false,
    disablePadding: true,
    label: 'Allocation End Date',
    type: 'Text'
  },
  {
    id: 'effectiveBillingStartDate',
    numeric: false,
    disablePadding: true,
    label: 'Billing Start Date',
    type: 'Text'
  },
  {
    id: 'effectiveBillingEndDate',
    numeric: false,
    disablePadding: true,
    label: 'Billing End Date',
    type: 'Text'
  },
  {
    id: 'allocationPercent',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Percent',
    type: 'Number',
    isSort: false
  },
  {
    id: 'billingPercent',
    numeric: false,
    disablePadding: true,
    label: 'Billing Percent',
    type: 'Number',
    isSort: false
  },
  {
    id: 'additionalFixedAmount',
    numeric: false,
    disablePadding: true,
    label: 'Flat Fee Amount',
    type: 'Number',
    isSort: false
  }
];
let temcurrentGroupedRow = [];
export default class ChangeInAllocationEmployeeByProperty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],
      employeeSummary: [],
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      maxEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      showReport: false,
      propertyMasterData: [],
      property: [{ propertyName: 'All' }],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Market',
              value: 'market',
              id: 'market',
              ssrsReport: 'Market',
              numeric: false,
              disablePadding: false,
              label: 'Market',
              type: 'Text',
              order: 2
            },
            {
              key: 'Client',
              value: 'clientName',
              id: 'clientName',
              ssrsReport: 'ClientName',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text',
              order: 3
            },
            {
              key: 'Property Name',
              id: 'propertyName',
              value: 'propertyName',
              ssrsReport: 'PropertyName',
              numeric: false,
              disablePadding: false,
              label: 'Property Name',
              type: 'Text',
              order: 4
            }
          ],
          selected: [{
            key: 'Employee',
            value: 'employee',
            id: 'employee',
            ssrsReport: 'Employee',
            numeric: false,
            disablePadding: false,
            label: 'Employee',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate
      },
      marketMasterData: [],
      market: [{ marketName: 'All' }],
      employeeMasterData: [],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      clientListingMasterData: [],
      client: [{ clientName: 'All' }]
    };

    this.baseState = this.state;
  }

  // Method to get data before component are mounted
  componentDidMount() {
    this.GetMasterData();
  }

  // Get master data using API calls to fill the filter list
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      }
    ])
      .then(({
        propertyMasterData,
        marketMasterData,
        clientListingMasterData,
        employeeMasterData
      }) => {
        this._asyncRequest = null;
        if (propertyMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          propertyMasterData: propertyMasterData.data,
          marketMasterData: marketMasterData.data,
          clientListingMasterData: clientListingMasterData.data,
          employeeMasterData: employeeMasterData.data,
          supervisorEmployeeMasterData: employeeMasterData.data || []
        }, () => {
          if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
            this.handleSubmit();
          }          
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Go to Reports list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');

    const formattedDate = moment(date).format(DateFormat);
    if (name === 'startDate') {
      advanceFilterConfig.startDate = formattedDate;// getCurrentPayCycleStartDateByDate(date).format(DateFormat);

      this.setState({
        [name]: formattedDate// getCurrentPayCycleStartDateByDate(date).format(DateFormat)
      });
    } else {
      advanceFilterConfig.endDate = formattedDate;// getCurrentPayCycleEndDateByDate(date).format(DateFormat);

      this.setState({
        [name]: formattedDate // getCurrentPayCycleEndDateByDate(date).format(DateFormat)
      });
    }
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  renderTable = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        {/* <TableHead>
          <TableRow>
            {groupSequence.map((col, index) => (
              <TableCell key={'th' + col.value + index} >{getFormattedHeaders(col.key, 'Text')}</TableCell>
            ))}
            <TableCell>{getFormattedHeaders('Email', 'Text')}</TableCell>
            <TableCell>{getFormattedHeaders('Allocation Start Date', 'Text')}</TableCell>
            <TableCell>{getFormattedHeaders('Allocation End Date', 'Text')}</TableCell>
            <TableCell>{getFormattedHeaders('Billing Start Date', 'Text')}</TableCell>
            <TableCell>{getFormattedHeaders('Billing End Date', 'Text')}</TableCell>
            <TableCell>{getFormattedHeaders('Allocation Percent', 'Number')}</TableCell>
            <TableCell>{getFormattedHeaders('Billing Percent', 'Number')}</TableCell>
            <TableCell>{getFormattedHeaders('Flat Fee Amount', 'Number')}</TableCell>
          </TableRow>
        </TableHead> */}
        <TableBody> {this.renderTableRow(orderBy(employeeData, this.state.orderBy, this.state.order))}</TableBody>
      </Table>
    );
  };

  renderTableRow = (data) => {
    // return this.renderTableCell(
    //   getMultilevelGroupedData(data,
    //     this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)),
    //   []);
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
        ),
        []
      );
    } else {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          [] // this.state.advanceFilterConfig.groupBy.masterData.map((x) => x.value)
        ),
        []
      );
    }
  };

  GetChangeInPropertyAllocation = () => {
    const { startDate, endDate, property, market, employee, client, SupervisorEmployee } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      startDate: moment(startDate).format(DateFormat),
      endDate: moment(endDate).format(DateFormat),
      propertyId: propertyId.join('|'),
      marketId: marketId.join('|'),
      employeeId: employeeId.join('|'),
      clientId: clientId.join('|'),
      supervisorId: supervisorId.join('|')
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetChangeInPropertyAllocation,
        params,
        key: 'employeeData'
      }
    ])
      .then(({ employeeData }) => {
        this._asyncRequest = null;
        if (employeeData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          employeeData: employeeData.data,
          employeeSummary: employeeData.config,
          showReport: true,
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  onAddvanceFilterChange = (advanceFilterConfig) => {
    // temcurrentGroupedRow = [];
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    const endDate = getValidEndDate(advanceFilterConfig);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      startDate: getCurrentPayCycleStartDateByDate(advanceFilterConfig.startDate),
      endDate: getCurrentPayCycleEndDateByDate(endDate)
    }, () => this.GetChangeInPropertyAllocation());

    ;
  }

  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.groupBy.selected.length === 0) {
      return removeDuplicates(
        [
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    } else {
      return removeDuplicates(
        [
          ...this.state.advanceFilterConfig.groupBy.selected,
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    }
  }

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    // temcurrentGroupedRow = [];
    this.GetChangeInPropertyAllocation();
  };

  resetPage = () => {
    localStorage.setItem('selectedstartDate', getCurrentPayCycleStartDateByDate(moment().format(DateFormat)));
    localStorage.setItem('selectedendDate', getCurrentPayCycleEndDateByDate(moment().format(DateFormat)));
    localStorage.setItem('DateRadioSelect', 'CDR');
    const { advanceFilterConfig } = this.state;
    // advanceFilterConfig.summaryRows = false;
    // advanceFilterConfig.suppressZero = false;
    advanceFilterConfig.startDate = getCurrentPayCycleStartDateByDate(moment().format(DateFormat));
    advanceFilterConfig.endDate = getCurrentPayCycleEndDateByDate(moment().format(DateFormat));
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Market',
          value: 'market',
          id: 'market',
          ssrsReport: 'Market',
          numeric: false,
          disablePadding: false,
          label: 'Market',
          type: 'Text',
          order: 2
        },
        {
          key: 'Client',
          value: 'clientName',
          id: 'clientName',
          ssrsReport: 'ClientName',
          numeric: false,
          disablePadding: false,
          label: 'Client',
          type: 'Text',
          order: 3
        },
        {
          key: 'Property Name',
          id: 'propertyName',
          value: 'propertyName',
          ssrsReport: 'PropertyName',
          numeric: false,
          disablePadding: false,
          label: 'Property Name',
          type: 'Text',
          order: 4
        }
      ],
      selected: [{
        key: 'Employee',
        value: 'employee',
        id: 'employee',
        ssrsReport: 'Employee',
        numeric: false,
        disablePadding: false,
        label: 'Employee',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    });
    this.componentDidMount();
  };

  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const sequence = this.getColumnSequence();

    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;
      if (d.data !== undefined) {
        // rowCount = 0;
        // currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        // currentGroupedRow.push({ key: d.key, value: d[d.key] });
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }

      const keyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));
      // const sequence = this.getColumnSequence();
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !== (keyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
      const key = d.market + '_' + d.employeeId + '_' + d.propertyName + '_' + d.clientName + '_' + rowCount + '_' + i;
      if (d.data === undefined) {
        tableCell.push(
          <TableRow key={key} className={topBorderClass}>
            <TableCell className={evenOddClass + topBorderClass}>
              {getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')}{' '}

            </TableCell>
            <TableCell className={evenOddClass + ((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')}>
              {getFormattedValues((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value], 'Text')}{' '}

            </TableCell>
            <TableCell className={evenOddClass + // topBorderClass
              ((column3 !== d[sequence[2].value] || (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])) ? ' rpt-topBorder ' : ' ')
            }>
              {getFormattedValues((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[2].value], 'Text')}{' '}
            </TableCell>
            <TableCell className={evenOddClass + // 'rpt-topBorder'
              ((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
            }>
              {getFormattedValues((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[3].value], 'Text')}{' '}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {getFormattedValues(d.email, 'Text')}{' '}
            </TableCell>
            {changeInAllocationEmployeeByProperty.map((element, ind) =>
            (
              <TableCell key={key + ind} className={evenOddClass + 'rpt-topBorder'}>
                {getFormattedValues(d[element.key], element.format)}{' '}
              </TableCell>
            ))}
          </TableRow>
        );
      }
      rowCount++;
      column1 = (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 = (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 = (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 = (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
    }
    );
    return tableCell;
  };

  downloadFile = (fileMimeType, type, isPrint) => {
    const { market, employee, advanceFilterConfig, startDate, endDate, client, property, SupervisorEmployee } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];
    if (market && market.length > 0) {
      market.forEach(x => {
        if (x.marketId !== undefined) {
          dataValue.push({ key: 'MarketId', value: x.marketId });
        }
      });
    }
    if (property && property.length > 0) {
      property.forEach(x => {
        if (x.propertyId !== undefined) {
          dataValue.push({ key: 'PropertyId', value: x.propertyId });
        }
      });
    }
    if (client && client.length > 0) {
      client.forEach(x => {
        if (x.clientId !== undefined) {
          dataValue.push({ key: 'ClientId', value: x.clientId });
        }
      });
    }
    if (employee && employee.length > 0) {
      employee.forEach(x => {
        if (x.employeeId !== undefined) {
          dataValue.push({ key: 'EmployeeId', value: x.employeeId });
        }
      });
    }
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }

    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Employee%20Allocation%20Change%20by%20Property%20Report', type);
    downloadReport(
      url,
      // 'Change In Employee Allocation By Property Report',
      'Employee Allocation Activity by Property Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      propertyMasterData,
      showReport,
      marketMasterData,
      employeeMasterData,
      clientListingMasterData,
      openSlidingPanel,
      advanceFilterConfig,
      maxEndDate,
      supervisorEmployeeMasterData
    } = this.state;
    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (clientListingMasterData.find(x => x.clientName === 'All') === undefined) {
      clientListingMasterData.unshift({ clientName: 'All' });
    }
    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }
    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }
    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Change_in_Employee_Allocation_By_Property_Report'}
                title={'Employee Allocation Activity by Property Report'}
                actionsConfig={[
                  {
                    icon: <ArrowBackIcon size="small" className="back-button" />,
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Employee Allocation Activity by Property Report
            </PageHeader>
              <Grid container spacing={3} className='no-print row bottom-xs'>
                <Grid item xs={12} lg={3} >
                  <Grid item xs={12} style={{ marginLeft: '1.3rem' }}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginLeft: '1.3rem' }}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      value={this.state.employee}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee"
                        // placeholder="Employee"
                        />
                      )}
                    />

                  </Grid>
                  <Grid item xs={12} style={{ marginLeft: '1.3rem' }}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.SupervisorEmployee || ''}
                      options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} lg={3}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(clientListingMasterData, 'clientName')}
                      getOptionLabel={(option) => option.clientName}
                      value={this.state.client}
                      onChange={(e, val) => this.handleChange(e, val, 'client', 'clientName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Client"
                        // placeholder="Client"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      value={this.state.property}
                      onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                      id="tags-standard"
                      options={removeDuplicates(propertyMasterData, 'propertyName')}
                      limitTags={2}
                      getOptionLabel={(option) => option.propertyName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Property Name"
                        // placeholder="Property Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Start Date"
                          // maxDate={maxEndDate} // {endDate}
                          format="MM/dd/yyyy"
                          name="startDate"
                          value={startDate}
                          onChange={(e) => this.handleDateChange(e, 'startDate')}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          shouldDisableDate={this.disableDatesForPayCycleStart}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="End Date"
                          format="MM/dd/yyyy"
                          name="endDate"
                          minDate={startDate}
                          value={endDate}
                          onChange={(e) => this.handleDateChange(e, 'endDate')}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          shouldDisableDate={this.disableDatesForPayCycleEnd}
                        // maxDate={getCurrentPayCycleEndDateByDate(moment().format('MM/DD/YYYY'))}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={employeeData}
                />

              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && employeeData == null && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && (
                <div>
                  {employeeData !== null && (
                    <div className="container" style={{ marginTop: '1rem' }}>
                      <TableContainer component={Paper}>
                        {this.renderTable(employeeData)}
                      </TableContainer>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
      </div>
    );
  }
}
